import { Card, ListGroup } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { hthConfigOptions } from 'src/app-config';
import { logServices } from 'src/services';
import { typeLogObj, typeLogsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetCurrentUser, useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    activeLog: typeLogsDoc;
    congregationForLogs: number;
    setActiveLog: Dispatch<SetStateAction<typeLogsDoc | null>>;
    setLogs: Dispatch<SetStateAction<typeLogsDoc[] | null>>;
};

export const LogsCard: FC<propsType> = ({ activeLog, congregationForLogs, setActiveLog, setLogs }) => {
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const user = useGetCurrentUser();

    const maskBlockAndFaceHandler = (log: string) => {
        hthConfigOptions.blocks.forEach(b => {
            log = log.replace(`manzana ${b}`, `manzana ${generalHthHelper.MaskTheBlock(b, config.isUsingLettersForBlocks)}`);
            log = log.replace(`Manzana ${b}`, `Manzana ${generalHthHelper.MaskTheBlock(b, config.isUsingLettersForBlocks)}`);
        });
        hthConfigOptions.faces.forEach(f => {
            log = log.replace(`cara ${f}`, `cara ${generalHthHelper.MaskTheFace(f, config.isUsingLettersForBlocks)}`);
            log = log.replace(`Cara ${f}`, `Cara ${generalHthHelper.MaskTheFace(f, config.isUsingLettersForBlocks)}`);
        });
        return log;
    }

    const setEveryLogOfType = async (all = true): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await logServices.GetAll(all, activeLog.type, congregationForLogs);
        dispatch(hideLoadingModalReducer());
        const logs = response.data?.log?.logs;
        if (!logs) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        setLogs(x => !x ? x : x.map(l => l.congregation === congregationForLogs && l.type === activeLog.type ? ({
            ...l,
            hasAll: true,
            logs
        }) : l));
        setActiveLog(l => l ? ({
            ...l,
            hasAll: true,
            logs
        }) : l);
    }

    const deleteLog = (log: typeLogObj) => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: '¿Eliminar?',
            animation: 3,
            message: `Se va a eliminar este log de '${activeLog.title}' de la congregación ${activeLog.congregation}: ${log.logText}`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await logServices.Delete(activeLog.congregation, log);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                await setEveryLogOfType(activeLog.hasAll);
            }
        }));
    }

    return (
        <Card className={`${isDarkMode ? 'bg-dark text-white' : ''} my-4`}>
            <Card.Header className={'text-center h1 py-4'}>
                <div className={'mb-3'}>
                    {activeLog.title} <span className={'small fs-5'}>(viendo {activeLog.logs.length})</span>
                </div>
                {!activeLog.hasAll && activeLog.logs.length === 200 &&
                    <button className={'btn btn-general-blue d-block mt-3 mx-auto'} onClick={() => setEveryLogOfType()}>
                        Traer también los más viejos
                    </button>
                }
            </Card.Header>
            <ListGroup variant={'flush'} className={'border-top border-bottom'}>
                {activeLog.logs.map((log, i) =>
                    <ListGroup.Item key={i}
                        className={`d-flex justify-content-between align-items-center ${isDarkMode ? 'bg-dark text-white' : ''}`}
                    >
                        <span>
                            {maskBlockAndFaceHandler(log.logText)}
                        </span>
                        {user.isSuperAdmin &&
                            <button className={'btn btn-general-red btn-sm'}
                                onClick={() => deleteLog(log)}
                            >
                                Eliminar
                            </button>
                        }
                    </ListGroup.Item>
                )}
            </ListGroup>
        </Card>
    );
}
